"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BootstrapPanel", {
  enumerable: true,
  get: function get() {
    return _Panel["default"];
  }
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _ThemeProvider = require("../ThemeProvider");

var _Panel = _interopRequireDefault(require("react-bootstrap/lib/Panel"));

var _style = _interopRequireDefault(require("./style"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint-disable complexity */
var StiloPanel = function StiloPanel(_ref) {
  var classes = _ref.classes,
      id = _ref.id,
      header = _ref.header,
      panelstate = _ref.panelstate,
      children = _ref.children,
      addCls = _ref.addCls,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "id", "header", "panelstate", "children", "addCls"]);
  var TopBar = !panelstate ? header : /*#__PURE__*/_react["default"].createElement("div", {
    className: addCls ? ' ' + addCls : ''
  }, /*#__PURE__*/_react["default"].createElement("span", null, header), /*#__PURE__*/_react["default"].createElement("span", {
    className: "panelstate"
  }, panelstate));
  var bodyComp = _react["default"].Children.toArray(children).find(function (child) {
    return child.type == _Panel["default"].Body;
  }) // if there is a Body provided
  ? children // then use that
  :
  /*#__PURE__*/
  _react["default"].createElement(_Panel["default"].Body, null, children); // else we need to wrap like the previous version did

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.Panel + (addCls ? ' ' + addCls : '')
  }, /*#__PURE__*/_react["default"].createElement(_Panel["default"], (0, _extends2["default"])({
    id: id
  }, props), TopBar ? /*#__PURE__*/_react["default"].createElement(_Panel["default"].Heading, null, TopBar) : null, bodyComp));
};
/* eslint-enable complexity*/


StiloPanel.propTypes = {
  id: _propTypes["default"].string,
  header: _propTypes["default"].string,
  panelstate: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  children: _propTypes["default"].node,
  classes: _propTypes["default"].object,
  addCls: _propTypes["default"].string
};
var ThemedStiloPanel = (0, _ThemeProvider.withStyles)(_style["default"])(StiloPanel);
exports["default"] = ThemedStiloPanel;
//# sourceMappingURL=bootstrap.js.map